import { createContext } from 'react';

export interface TestTagContextProps {
  isTesting: boolean;
}

export const TestTagContext = createContext<TestTagContextProps>(undefined!);
